module.exports = __webpack_public_path__ + "img/b65b24f.jpg";